import { FC } from "react";
import { Button, Col, Modal, Row, Tooltip, Typography } from "antd";
import {
  ConditionalTooltipText,
  PdfFileIcon,
  ScrollableWrapper,
} from "../../components";
import { GlobalModalStyles, StyledTag } from "./styled";
import { convertBimRequest } from "../../utils";
import { TDocument, TDocumentForModal } from "../../types";
import { CloseClipboard } from "../icons/CloseClipboard";
import { CloseIcon } from "../icons/CloseIcon";

interface IDocumentsModalProps {
  selectedDocument: TDocumentForModal;
  currentDocument?: TDocument;
  onCancel: () => void;
  onChoosePdf: (document: TDocument) => void;
  onOpenAddCommentModal?: (document: TDocument) => void;
}

export const DocumentsModal: FC<IDocumentsModalProps> = ({
  selectedDocument,
  currentDocument,
  onCancel,
  onChoosePdf,
  onOpenAddCommentModal,
}) => {
  const renderDocsModalRow = (document: TDocument) => (
    <Row
      align="middle"
      justify="space-between"
      className="docs-modal-row"
      key={document.id}
    >
      <Col span={14}>
        <PdfFileIcon />

        <a
          target="_blank"
          rel="noopener noreferrer"
          href={convertBimRequest(document)}
        >
          <ConditionalTooltipText text={document.name} withoutBreaks />
        </a>

        {/* Пока что открываем пдф файлы в новой вкладке */}
        {false && (
          <Button onClick={() => onChoosePdf(document)} type="link">
            {document.name}
          </Button>
        )}
      </Col>

      <Col span={4}>
        <Typography.Text color="#007BFB">
          {document.revisionNumber}
        </Typography.Text>
      </Col>

      <Col span={4}>
        {document.isUpdated && (
          <StyledTag color={"#faad14"}>Обновлено</StyledTag>
        )}
      </Col>

      <Tooltip
        placement="topLeft"
        title={
          <>
            <div>Оставить</div>
            <div>замечание</div>
          </>
        }
      >
        <button  style={{border:"none", background: "unset"}} onClick={() => onOpenAddCommentModal!(document)}>
          <CloseClipboard />
        </button>
      </Tooltip>
    </Row>
  );

  return (
    <>
      <GlobalModalStyles />

      <Modal
        closeIcon={<CloseIcon />}
        className="docs-modal"
        title={selectedDocument.title}
        open={!!selectedDocument}
        onCancel={onCancel}
        footer={null}
      >
        {currentDocument && (
          <Col span={32} style={{ display: "flex", alignItems: "center" }}>
            <PdfFileIcon />

            <a
              target="_blank"
              rel="noopener noreferrer"
              href={convertBimRequest(currentDocument!)}
            >
              <ConditionalTooltipText
                text={currentDocument.name}
                withoutBreaks
              />
            </a>

            {/* Пока что открываем пдф файлы в новой вкладке */}
            {false && (
              <Button onClick={() => onChoosePdf(currentDocument!)} type="link">
                {currentDocument?.name}
              </Button>
            )}
          </Col>
        )}
        {selectedDocument?.documents?.length ? (
          <ScrollableWrapper maxHeight={window.innerHeight - 177}>
            <Row className="docs-header-row">
              <Col span={16}>
                <Typography.Text type="secondary">
                  Название тома
                </Typography.Text>
              </Col>

              <Col span={4}>
                <Typography.Text type="secondary">Версия</Typography.Text>
              </Col>

              <Col span={4} />
            </Row>

            {selectedDocument?.documents.map((el) => renderDocsModalRow(el))}
          </ScrollableWrapper>
        ) : (
          <Row justify="center">
            <Typography.Text strong>Нет доступных документов</Typography.Text>
          </Row>
        )}
      </Modal>
    </>
  );
};
